import React from 'react';
import { Progress } from '@/components/ui/progress';
import { Truck, Sparkles } from 'lucide-react';
import { useApp } from '@/state/AppContext';
import { inr } from '@/lib/format';

export const FreeShippingBar = ({ className = '' }) => {
  const { subtotal, config } = useApp();
  const threshold = config.free_shipping_threshold || 499;
  const remaining = Math.max(0, threshold - subtotal);
  const pct = Math.min(100, Math.round((subtotal / threshold) * 100));
  const qualified = subtotal >= threshold;

  return (
    <div className={className} data-testid="free-shipping-progress">
      <div className="flex items-center justify-between gap-3 text-xs font-medium">
        <div className="flex items-center gap-2 text-foreground">
          {qualified ? (
            <>
              <Sparkles className="w-4 h-4 text-[var(--bb-pink)]" />
              <span>You’ve unlocked FREE shipping!</span>
            </>
          ) : (
            <>
              <Truck className="w-4 h-4 text-[var(--bb-pink)]" />
              <span>Add {inr(remaining)} more for FREE shipping</span>
            </>
          )}
        </div>
        <span className="text-muted-foreground">{pct}%</span>
      </div>
      <Progress value={pct} className="mt-2 h-2 bg-[var(--bb-sky-soft)]" />
    </div>
  );
};
